import PropTypes from 'prop-types'
import React from 'react'
import { useQuery } from '@tanstack/react-query'
import { CircularProgress, makeStyles } from '@material-ui/core'
import { useAppContext } from '../../../../../redux/slices/appContext'
import { postNamedQuery } from '../../../../../service'
import { useFormattingContext } from '../../../FormattingProvider/FormattingContext'
import { QUERY_KEYS } from '../../../../../api/queryKeys'
import { AccountList } from './AccountList'

const useStyles = makeStyles({
  container: {
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
    overflow: 'hidden'
  },
  marketValueContainer: {
    minHeight: '80px',
    borderRadius: 'var(--border-radius-lg)',
    padding: 'var(--padding-md)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  }
})

export const AccountCategoryDetails = ({
  entityProps
}) => {
  const { formatter } = useFormattingContext()
  const { clientId, availableDates } = useAppContext()

  const classes = useStyles()

  const { data, isLoading } = useQuery({
    queryKey: [QUERY_KEYS.entityGraphs, clientId, entityProps.levelTypeId, entityProps.levelId],
    queryFn: async () => {
      const response = await postNamedQuery('coreData', 'getGroupedCoreData', {
        levelFilters: {
          calcType: 'balance',
          dateType: 'all',
          clientIds: [clientId],
          levelTypes: ['client', 'accountCategory'],
          accountCategoryIds: [entityProps.levelId],
          V2: true
        },
        dateRange: {
          startDate: availableDates.min,
          endDate: availableDates.max
        }
      })

      return response?.data?.[0] || {}
    },
    enabled: !!entityProps.levelId && !!clientId && !!availableDates.min && !!availableDates.max
  })

  return (
    <div className={classes.container}>
      <div
        className={classes.marketValueContainer}
        style={{ backgroundColor: entityProps?.color }}
      >
        {isLoading ? <CircularProgress /> : (
          <span className='font-size-xl'>{formatter(data?.endingValue ?? 0, '$0,0[.]0A')}</span>
        )}
      </div>
      <AccountList entityProps={entityProps} accountCategory={data} />
    </div>
  )
}

AccountCategoryDetails.propTypes = {
  entityProps: PropTypes.shape({
    levelTypeId: PropTypes.number.isRequired,
    levelId: PropTypes.number.isRequired,
    color: PropTypes.string
  })
}
